"use strict";

import angular from "angular";

import template from "./toast-recommendation.component.html";
import "./toast-recommendation.component.scss";

class ToastRecommendationComponent {
    constructor(ToastRecommendationService) {
        this.ToastRecommendationService = ToastRecommendationService;
        this.isOpen = false;
    }

    $onInit() {
        this.ToastRecommendationService.onToggle(() => {
            this.toggle();
        });

        this.ToastRecommendationService.onOpen(() => {
            this.open();
        });

        this.ToastRecommendationService.onClose(() => {
            this.close();
        });
    }

    toggle() {
        this.isOpen = !this.isOpen;
    }

    open() {
        this.isOpen = true;
    }

    close() {
        this.isOpen = false;
    }
}

ToastRecommendationComponent.$inject = ["ToastRecommendationService"];

const name = "toastRecommendationComponent";
const def = {
    controller: ToastRecommendationComponent,
    
    transclude: {
        header: "toastHeader",
        body: "toastBody"
    },
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
